module.exports = __webpack_public_path__ + "img/Thermometer.cbd69f43.svg";